import edit from './edit';
import add from './add';
import list from './list';

const module = {
  namespaced: true,
  modules: {
    edit,
    add,
    list,
  },
};

export default module;
